import {copy} from '../../../../../../../util/fieldscopy'
import {FormSectionType} from '../../../../../../blocks/FormBlock'
import box from '../../fields/box'
import city from '../../fields/city'
import companyName from '../../fields/copmanyName'
import deliveryOptions from '../../fields/deliveryOptions'
import houseNumber from '../../fields/houseNumber'
import street from '../../fields/street'
import zip from '../../fields/zip'
import defaultDeliveryData from '../personal/deliveryData'

const deliveryData: FormSectionType = {
	...defaultDeliveryData,
	fields: [
		{
			...deliveryOptions,
			options: [
				{
					path: 'client',
					title:
						copy?.address?.same_as_client || 'Zelfde adres als klantengegevens'
				},
				{
					path: 'personal',
					title:
						copy?.address?.same_as_person || 'Zelfde adres als persoonsgegevens'
				},
				{
					path: 'other',
					title: copy?.address?.other || 'Gebruik een ander adres'
				}
			]
		},
		{...companyName, required: true},
		street,
		houseNumber,
		box,
		zip,
		city
	].map((field) => {
		return {...field, parent_id: 3}
	})
}

export default deliveryData
